export default __webpack_public_path__ + "static/fonts/InclusiveSans-Regular_rIoYIw.ttf";